
import { useState, useEffect } from 'react'
import { supabase } from '@/integrations/supabase/client'
import { useToast } from '@/hooks/use-toast'

export const useModulesForDropdown = () => {
  const [modules, setModules] = useState<Array<{ value: string; label: string; category: string }>>([])
  const [loading, setLoading] = useState(true)
  const { toast } = useToast()

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const { data, error } = await supabase
          .from('learn_modules')
          .select('id, title, category')
          .order('category, title')

        if (error) throw error

        // Transform modules into dropdown options with category
        const moduleOptions = (data || []).map(module => ({
          value: module.title.toLowerCase().replace(/\s+/g, '-'),
          label: module.title,
          category: module.category
        }))

        setModules(moduleOptions)
      } catch (error: any) {
        console.error('Error fetching modules:', error)
        toast({
          title: "Error fetching modules",
          description: "Failed to load module options",
          variant: "destructive",
        })
      } finally {
        setLoading(false)
      }
    }

    fetchModules()

    // Set up real-time subscription for module changes
    const channel = supabase
      .channel('modules-dropdown-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'learn_modules'
        },
        () => {
          fetchModules()
        }
      )
      .subscribe()

    return () => {
      supabase.removeChannel(channel)
    }
  }, [toast])

  return { modules, loading }
}
